import WhatsAppLogo from '@/assets/images/channels/whatsapp.png';
import {
  type BaseModalFCProps,
  type ModalFC,
} from '@/components/modals/modalsManager';
import { ChannelConnectModal } from '@/features/msg-channels/common/ChannelConnectModal';
import { MessagingChannelTypes } from '@/features/msg-channels/common/msg-channels.types';

export type WhatsAppChannelConnectModalProps = BaseModalFCProps & {
  currentIdentifier?: string | null;
};

export const WhatsAppChannelConnectModal: ModalFC<
  WhatsAppChannelConnectModalProps
> = (props) => (
  <ChannelConnectModal
    {...props}
    channelType={MessagingChannelTypes.WHATSAPP_BUSINESS}
    channelName="WhatsApp"
    channelIconSrc={WhatsAppLogo}
    openButtonLabel="Open in WhatsApp"
  />
);
